import { useWorkspace } from 'wrappers/WorkspaceProvider';

import type { Permission } from '@fragment/authorization-utils';
import { rolePermissions } from '@fragment/authorization-utils/rolePermissions';

export const useHasWorkspacePermission = (permission: Permission): boolean => {
  const { workspace } = useWorkspace();
  return workspace ? rolePermissions[workspace.role].has(permission) : false;
};
